var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamrahDoctorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0469 45.9429C19.9854 50.1692 29.6576 49.5386 35.25 39.8448C39.6907 32.1353 39.7693 19.5165 30.1078 12.191C29.6638 11.8595 29.2829 12.0168 28.9453 12.2311C27.0025 13.4508 24.8577 15.9209 24.0868 19.3253C22.9581 24.2871 25.2478 26.8991 27.0164 30.2804C30.5396 38.3985 23.1185 47.6652 14.6813 45.613C13.952 45.3262 13.2504 45.5174 13.053 45.9445L13.0469 45.9429Z",
    fill: "#3290FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0163 46.3932C22.9352 54.1027 36.2001 50.3775 42.3861 38.562C44.3284 34.8126 45.5075 30.7152 45.8553 26.507C46.203 22.2988 45.7125 18.0634 44.4121 14.046C44.187 13.3537 43.6319 13.5171 43.1262 13.8317C38.001 16.9848 35.5201 21.7678 35.1901 27.1567C35.0359 29.6499 35.83 31.309 35.4137 34.0381C33.73 45.0317 22.7394 50.433 13.3416 45.6346C13.2121 45.708 13.1105 45.8223 13.0527 45.9595C12.995 46.0968 12.9843 46.2493 13.0224 46.3932H13.0163Z",
    fill: "#3290FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8804 47.2089C17.8893 49.9658 22.8742 51.6804 27.6109 51.5262C37.2169 51.2394 45.2439 45.3586 48.4372 37.1049C49.319 34.745 49.8434 32.2665 49.9929 29.7517C50.0716 28.5922 49.4872 28.5073 48.6284 28.66C46.4106 29.0517 44.3471 30.0574 42.6723 31.563C40.9974 33.0686 39.7783 35.0137 39.1535 37.1774C37.553 42.7081 33.4331 46.3423 29.9129 47.9243C25.1871 50.0506 18.8314 50.3482 13 46.2529C13 46.6353 13.3932 46.8697 13.8804 47.2089Z",
    fill: "#3290FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamrahDoctorLogo);
export default __webpack_public_path__ + "static/media/hamrah-doctor-logo.151d8dfbd25e06f26b59fc2788b93fbf.svg";
export { ForwardRef as ReactComponent };